/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 12:03:27 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Datagrid,
  FunctionField,
  List,
  TextField,
  Title,
  usePermissions,
} from 'react-admin';
import ListActions from './actions';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';
import { PostPagination } from '../../Components/CustomPagination/pagination';

const RegionList = props => {
  const { permissions } = usePermissions();
  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        bulkActionButtons={false}
        perPage={25}
        pagination={<PostPagination />}
        actions={<ListActions />}
        {...props}
      >
        <Datagrid rowClick="edit">
          <TextField
            source="name"
            label={'resources.Region.fields.regionName'}
            sortable={false}
          />
          <FunctionField
            label={'resources.Region.fields.noCountries'}
            render={record => record.countries && record.countries.length}
          />
        </Datagrid>
      </List>
    </>
  ) : (
    <AccessDenied />
  );
};

export default RegionList;
